export interface PartnerConnection {
    id: string;
    accountId: string;
    partnerName: string;
    partnerDisplayName: string;
    status: PartnerConnectionStatus;
    createdAt: string;
}

// biome-ignore lint/style/noEnum: Preserve the established enum values and runtime API used by existing callers
export enum PartnerConnectionStatus {
    ACTIVATED = 'activated',
    FAILED_ACTIVATION = 'failed-activation',
    FAILED_DEACTIVATION = 'failed-deactivation',
}

export interface PartnersState {
    connections: PartnerConnection[];
    permissions: boolean;
}
